
import * as idtechGumletRuntime$MugCjlFlDT from '/var/www/html/providers/gumlet.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "idtechGumlet",
  "domains": [],
  "alias": {}
}

imageOptions.providers = {
  ['idtechGumlet']: { provider: idtechGumletRuntime$MugCjlFlDT, defaults: {"baseURL":"idtech.gumlet.io"} }
}
        